<template>
  <div v-if="lastPage > 1" class="flex items-center justify-center gap-2 py-4">
    <button
      :disabled="currentPage <= 1"
      class="px-3 py-1.5 rounded-lg text-sm font-bold transition"
      :class="currentPage <= 1 ? 'text-neutral cursor-not-allowed' : 'text-primary-dark hover:bg-neutral-light'"
      @click="$emit('page-change', currentPage - 1)"
    >
      <i class="ph ph-caret-left"></i>
      {{ labels.previous }}
    </button>

    <template v-for="p in visiblePages" :key="p">
      <span v-if="p === '...'" class="px-2 text-neutral">...</span>
      <button
        v-else
        class="w-9 h-9 rounded-lg text-sm font-bold transition"
        :class="p === currentPage ? 'bg-primary-dark text-white' : 'text-primary-dark hover:bg-neutral-light'"
        @click="$emit('page-change', p)"
      >
        {{ p }}
      </button>
    </template>

    <button
      :disabled="currentPage >= lastPage"
      class="px-3 py-1.5 rounded-lg text-sm font-bold transition"
      :class="currentPage >= lastPage ? 'text-neutral cursor-not-allowed' : 'text-primary-dark hover:bg-neutral-light'"
      @click="$emit('page-change', currentPage + 1)"
    >
      {{ labels.next }}
      <i class="ph ph-caret-right"></i>
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  currentPage: { type: Number, required: true },
  lastPage: { type: Number, required: true },
  labels: { type: Object, required: true },
});

defineEmits(['page-change']);

const visiblePages = computed(() => {
  const pages = [];
  const current = props.currentPage;
  const last = props.lastPage;

  if (last <= 7) {
    for (let i = 1; i <= last; i++) pages.push(i);
    return pages;
  }

  pages.push(1);

  if (current > 3) pages.push('...');

  const start = Math.max(2, current - 1);
  const end = Math.min(last - 1, current + 1);

  for (let i = start; i <= end; i++) pages.push(i);

  if (current < last - 2) pages.push('...');

  pages.push(last);

  return pages;
});
</script>
